import { defineMessages } from 'react-intl'

const messages = {
  title: {
    id: 'app.components.hamburger-menu.title',
    defaultMessage: 'Active Orders',
  },
  ariaLabel: {
    id: 'app.components.hamburger-menu.aria-label',
    defaultMessage: 'Menu',
  },
}

export default defineMessages(messages)
